export default __webpack_public_path__ + "static/media/sketch11.fc5ecbb9.jpg";